// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Article_header__1mkyP {
  margin-bottom: 12px;
}

.Article_titleBack__wwR8H {
  margin-bottom: 24px;
}

.Article_headerTop__uVCM2,
.Article_headerBot__K8M6t,
.Article_titleLoading__VTtKi,
.Article_creatorLoading__dwJvG {
  margin-bottom: 12px;
}

.Article_headerTop__uVCM2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Article_headerBot__K8M6t {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  color: #7A808B;
  font-size: var(--fz-sm);
  line-height: var(--lh-sm);
}

.Article_title__salVs {
  font-weight: 600;
  padding-right: 10px;
}

.Article_avatar__oEJmE {
  margin-right: 4px;
}

.Article_dot__IzXMx {
  display: inline-block;
  flex-shrink: 0;
  width: 3px;
  height: 3px;
  border-radius: 100%;
  background-color: var(--text-color);
  margin: 0 5px;
}

.Article_article__VVLVb {
  color: var(--gray-950);
  overflow-x: auto;
  line-height: normal;
}
.Article_article__VVLVb img {
  max-width: 100%;
  max-height: 400px;
  object-fit: cover;
  object-position: center;
  height: auto;
}
.Article_article__VVLVb p > img {
  vertical-align: top;
  padding: 2px;
}
.Article_article__VVLVb h2, .Article_article__VVLVb h3, .Article_article__VVLVb p, .Article_article__VVLVb pre {
  margin-bottom: 12px;
}
.Article_article__VVLVb h2, .Article_article__VVLVb h3 {
  color: var(--text-color);
  font-weight: normal;
}
.Article_article__VVLVb p {
  font-size: 14px;
  line-height: 22px;
}
.Article_article__VVLVb pre {
  background-color: var(--gray-950);
  color: var(--white);
  border-radius: 4px;
  padding: 12px;
  margin-top: 0;
}
.Article_article__VVLVb ul {
  padding-inline-start: 40px;
}
.Article_article__VVLVb a {
  color: var(--accent-color);
  text-decoration: underline;
}
@media (hover: hover) {
  .Article_article__VVLVb a:hover {
    text-decoration: none;
  }
}
.Article_article__VVLVb table {
  border-collapse: collapse;
}
.Article_article__VVLVb th, .Article_article__VVLVb td {
  border: 1px solid;
}
.Article_article__VVLVb .table-container {
  width: 100%;
  overflow: auto;
}
.Article_article__VVLVb .file-node__weight {
  margin-left: 4px;
}

.Article_artTags__gZ7Lf {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 4px;
  margin-top: 10px;
}

.Article_titleLoading__VTtKi,
.Article_creatorLoading__dwJvG,
.Article_textLoading__OR71v {
  border-radius: 4px;
}

.Article_titleLoading__VTtKi {
  height: 28px;
}

.Article_creatorLoading__dwJvG {
  height: 22px;
}

.Article_textLoading__OR71v {
  height: 300px;
}`, "",{"version":3,"sources":["webpack://./src/components/Articles/Article/Article.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;;;;EAIE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,qBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,mCAAA;EACA,aAAA;AACF;;AAEA;EACE,sBAAA;EACA,gBAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;AACJ;AAEE;EACE,mBAAA;EACA,YAAA;AAAJ;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,wBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,eAAA;EACA,iBAAA;AAHJ;AAME;EACE,iCAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;AAJJ;AAOE;EACE,0BAAA;AALJ;AAQE;EACE,0BAAA;EACA,0BAAA;AANJ;AAQI;EACE;IACE,qBAAA;EANN;AACF;AAUE;EACE,yBAAA;AARJ;AAWE;EACE,iBAAA;AATJ;AAaI;EACE,WAAA;EACA,cAAA;AAXN;AAcI;EACE,gBAAA;AAZN;;AAiBA;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AAdF;;AAiBA;;;EAGE,kBAAA;AAdF;;AAiBA;EACE,YAAA;AAdF;;AAiBA;EACE,YAAA;AAdF;;AAiBA;EACE,aAAA;AAdF","sourcesContent":[".header {\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.titleBack {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.headerTop,\r\n.headerBot,\r\n.titleLoading,\r\n.creatorLoading {\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.headerTop {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.headerBot {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  color: #7A808B;\r\n  font-size: var(--fz-sm);\r\n  line-height: var(--lh-sm);\r\n}\r\n\r\n.title {\r\n  font-weight: 600;\r\n  padding-right: 10px;\r\n}\r\n\r\n.avatar {\r\n  margin-right: 4px;\r\n}\r\n\r\n.dot {\r\n  display: inline-block;\r\n  flex-shrink: 0;\r\n  width: 3px;\r\n  height: 3px;\r\n  border-radius: 100%;\r\n  background-color: var(--text-color);\r\n  margin: 0 5px;\r\n}\r\n\r\n.article {\r\n  color: var(--gray-950);\r\n  overflow-x: auto;\r\n  line-height: normal;\r\n\r\n  img {\r\n    max-width: 100%;\r\n    max-height: 400px;\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: auto;\r\n  }\r\n\r\n  p>img {\r\n    vertical-align: top;\r\n    padding: 2px;\r\n  }\r\n\r\n  h2, h3, p, pre {\r\n    margin-bottom: 12px;\r\n  }\r\n\r\n  h2, h3 {\r\n    color: var(--text-color);\r\n    font-weight: normal;\r\n  }\r\n\r\n  p {\r\n    font-size: 14px;\r\n    line-height: 22px;\r\n  }\r\n\r\n  pre {\r\n    background-color: var(--gray-950);\r\n    color: var(--white);\r\n    border-radius: 4px;\r\n    padding: 12px;\r\n    margin-top: 0;\r\n  }\r\n\r\n  ul {\r\n    padding-inline-start: 40px;\r\n  }\r\n\r\n  a {\r\n    color: var(--accent-color);\r\n    text-decoration: underline;\r\n\r\n    @media (hover: hover) {\r\n      &:hover {\r\n        text-decoration: none;\r\n      }\r\n    }\r\n  }\r\n\r\n  table {\r\n    border-collapse: collapse;\r\n  }\r\n\r\n  th, td {\r\n    border: 1px solid;\r\n  }\r\n\r\n  :global {\r\n    .table-container {\r\n      width: 100%;\r\n      overflow: auto;\r\n    }\r\n\r\n    .file-node__weight {\r\n      margin-left: 4px;\r\n    }\r\n  }\r\n}\r\n\r\n.artTags {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  grid-gap: 4px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.titleLoading,\r\n.creatorLoading,\r\n.textLoading {\r\n  border-radius: 4px;\r\n}\r\n\r\n.titleLoading {\r\n  height: 28px;\r\n}\r\n\r\n.creatorLoading {\r\n  height: 22px;\r\n}\r\n\r\n.textLoading {\r\n  height: 300px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Article_header__1mkyP`,
	"titleBack": `Article_titleBack__wwR8H`,
	"headerTop": `Article_headerTop__uVCM2`,
	"headerBot": `Article_headerBot__K8M6t`,
	"titleLoading": `Article_titleLoading__VTtKi`,
	"creatorLoading": `Article_creatorLoading__dwJvG`,
	"title": `Article_title__salVs`,
	"avatar": `Article_avatar__oEJmE`,
	"dot": `Article_dot__IzXMx`,
	"article": `Article_article__VVLVb`,
	"artTags": `Article_artTags__gZ7Lf`,
	"textLoading": `Article_textLoading__OR71v`
};
export default ___CSS_LOADER_EXPORT___;
